import { FC, ReactNode, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageHeader from "../components/commons/page-header";
import { BiMenu } from "react-icons/bi";
import mpower from "../assets/images/mpower.svg";
import { useState } from "react";
import { Button } from "../components/ui";
import logout from "../assets/images/logout.svg";
import { useDispatch, useSelector } from "react-redux";
import { handelLogout } from "../reducers/authSlice";
import { updateActiveTradeTab } from "../reducers/tradeSlice";
import { TRootState } from "../store";
import { setCustomerActiveTab } from "../reducers/customerSlice";
import {
  setIsCollapsed,
  setOpenTradeDetails,
  UpdateActiveTab,
} from "../reducers/trade_details_Slice";
import {
  resetLoanFilters,
  setOpenLoanDetails,
  setOpenLoansTabDetals,
  setSearchText,
} from "../reducers/loansSlice";
import { setActiveMarketTab } from "../reducers/marketSlice";
import { setMainTabs } from "../reducers/reports_slice";
import { NAV_ITEMS } from "./config/navigationConfig";
import { PAGE_CONFIG } from "./config/pageTitleConfig";
import { ROUTE_PERMISSIONS } from "../routes/routePermissions";
import useAxiosClient from "../hooks/useAxiosClient";

const PageLayout: FC<{ children: ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { userPermissions, adminId } = useSelector((state: TRootState) => ({
    userPermissions: state.auth.userPermissions,
    adminId: state.auth.adminId
  }));

  const { handlePostCall } = useAxiosClient();

  const [activeTab, setActiveTab] = useState("customers");
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const handleNavigation = (key: string) => {
    setActiveTab(key);
    const item = NAV_ITEMS[key.toLowerCase()];
    navigate(item.path);

    if (key === "trades") {
      dispatch(UpdateActiveTab("Open Trades"));
      dispatch(setIsCollapsed(false));
      dispatch(setOpenTradeDetails(false));
    }
    if (key === "customers") dispatch(setCustomerActiveTab("ALL"));
    if (key === "loans") {
      dispatch(setSearchText(""));
      dispatch(setOpenLoanDetails(false));
      dispatch(setOpenLoansTabDetals(false));
    }
    if (key === "Reports") dispatch(setMainTabs("operations"));
    if (key === "Markets") dispatch(setActiveMarketTab("ALL"));

    setIsOpen(false);
  };

  const handleLogoutFun = async () => {
    try {
      await handlePostCall({
        URL: "account/mos/logout",
        apiParams: [
          {
            userId: adminId,
            type: "MPOWER_ADMIN",
          },
        ],
        isAuthInstance: true,
      });
    } catch (error) {
      console.error("Admin logout API failed:", error);
    }


    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
    localStorage.clear();
    dispatch(handelLogout(null));
    dispatch(resetLoanFilters());
    navigate("/");
    window.location.reload();
    //@ts-ignore
    // oNoLocalStorage.set("LinkPath", "/smartboard", false);
    // //@ts-ignore
    // oNoLocalStorage.set("statusPlan", "FAILURE", false);
    // //@ts-ignore
    // oNoLocalStorage.set("LinkId", "1", false);
    //@ts-ignore
    localStorage.setItem("isauth", false);
  };

  const titles: Record<string, string> = {
    customers: "Customers",
    partners: "Partners",
    trades: "Trades",
    loans: "Loans",
    payments: "Payments",
    reports: "Reports",
    markets: "Markets",
    risk_engine: "Risk Engine",
    price_prediction: "Price Prediction",
    my_profile: "My Profile",
  };

  const [title, setTitle] = useState(titles[activeTab.toLowerCase()] || "");

  useEffect(() => {
    if (!userPermissions?.length) return;

    if (location.pathname === "/") {
      const firstPermission = userPermissions[0]?.permName.toLowerCase();
      const firstNav = NAV_ITEMS[firstPermission];

      if (firstNav) {
        navigate(firstNav.path, { replace: true });
      }

      return;
    }

    const matchedRoute = Object.keys(ROUTE_PERMISSIONS).find((route) =>
      location.pathname.startsWith(route)
    );

    if (!matchedRoute) return;

    const requiredPermission = ROUTE_PERMISSIONS[matchedRoute];

    const hasPermission = userPermissions.some(
      (permission: any) => permission.permName === requiredPermission
    );

    if (!hasPermission) {
      const firstPermission = userPermissions[0]?.permName.toLowerCase();
      const firstNav = NAV_ITEMS[firstPermission];

      if (firstNav) {
        navigate(firstNav.path, { replace: true });
      }
    }
  }, [location.pathname, userPermissions, navigate]);

  useEffect(() => {
    const page = PAGE_CONFIG.find((x) => x.match(location.pathname));

    if (!page) {
      const firstPermission = userPermissions?.[0]?.permName.toLowerCase();

      if (firstPermission) {
        setActiveTab(firstPermission);
        setTitle(NAV_ITEMS[firstPermission]?.label ?? "");
      }

      return;
    }

    setActiveTab(page.activeTab);

    if (typeof page.title === "function") {
      setTitle(page.title(location.pathname));
    } else {
      setTitle(page.title);
    }

    page.onEnter?.(dispatch);
  }, [location.pathname, userPermissions, dispatch]);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const closeSidebar = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="flex">
      <div
        className={`h-screen bg-white font-semibold flex-shrink-0 relative flex flex-col transition-all duration-500 ease-in-out ${isOpen
          ? "translate-x-0 fixed top-0 left-0 w-[200px] z-[9999]"
          : "-translate-x-full w-0"
          } md:translate-x-0 md:w-[200px] md:static border-r`}
        style={{
          position: isMobile ? "absolute" : "static",
        }}
      >
        <div className="border-b gap-4 flex items-center px-4 h-[3.8rem] flex-shrink-0">
          <img
            src={mpower}
            className="px-3 h-auto w-full max-w-[160px] object-contain"
            alt="Mandi Logo"
            loading="eager"
            decoding="async"
            fetchPriority="high"
          />
        </div>

        <ul className="pl-4 py-4 flex-1 overflow-y-auto overflow-x-hidden"
          id="scroll_style"
        >
          {userPermissions?.map((key: any) => {
            const item = NAV_ITEMS[key.permName.toLowerCase()];
            if (!item) return null;

            const Icon = item.icon;
            const isActive = activeTab === key.permName.toLowerCase();

            return (
              <li
                key={key.permName}
                className={`flex items-center gap-3 p-3 cursor-pointer mb-4 ${isActive ? "bg-primary" : ""
                  }`}
                style={{ borderRadius: "30px 0 0 30px" }}
                onClick={() =>
                  handleNavigation(key?.permName.toLowerCase())
                }
              >
                <div className={isActive ? "color-yellow" : "color-sub-text"}>
                  <Icon style={{ fontSize: 24 }} />
                </div>

                <p
                  className={`text-sm font-semibold ${isActive ? "color-yellow" : ""
                    }`}
                >
                  {item.label}
                </p>
              </li>
            );
          })}
        </ul>

        <div className="flex-shrink-0 p-3 border-t flex justify-center">
          <Button
            className="mx-auto"
            shape="round"
            variant="red"
            onClick={() => {
              handleLogoutFun();
              dispatch(updateActiveTradeTab(""));
            }}
          >
            <img src={logout} className="pr-2" alt="Logout" />
            Logout
          </Button>
        </div>
      </div>

      <div className="ml-auto grow h-screen overflow-auto relative">
        <div className="flex w-full relative shadow-md md:shadow-none">
          <header className="flex items-center md:hidden  px-2 bg-white sticky top-0 z-[999]">
            {isOpen ? (
              ""
            ) : (
              <BiMenu
                size={25}
                style={{ color: "green" }}
                onClick={() => {
                  toggleSidebar();
                }}
                className="block md:hidden p-2 text-gray-700"
              />
            )}
          </header>
          <PageHeader
            title={title}
            showTitle={true}
            showUserInfo={true}
            fromScreen={
              location.pathname.startsWith("/customer-details/")
                ? "Customer Details"
                : location.pathname.startsWith("/risk-engine/composition")
                  ? "Composition"
                  : title
            }
            showBackButton={
              location.pathname.startsWith("/customer-details/") ||
                location.pathname.startsWith("/risk-engine/composition")
                ? true
                : false
            }
          />
        </div>

        <div
          className={`overflow-auto ${location.pathname.startsWith("/customer-details/")
            ? "hide-scroll-bar"
            : ""
            } `}
          style={{
            height: "calc(100vh - 3.8rem)",
            backgroundColor: "#EFF3EF",
          }}
        >
          {children}
        </div>
      </div>

      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-70 z-[99] md:hidden"
          onClick={closeSidebar}
        />
      )}
    </div>
  );
};

export default PageLayout;
